import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {QbInvoiceDetailDto} from "../../model/QbInvoiceDetailDto";
import {ConfigService} from "../../modules/ConfigModule";

export default class ViewController implements Ng1Controller {
    private invoice: QbInvoiceDetailDto;
    private error: any;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any,
                private $config: ConfigService) {
        $dataHub.client.onInvoiceDetailUpdated(e => this.invoice = e);

        $dataHub.onConnected(this.refresh);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        this.$dataHub.server.invoiceDetailSubscribe(this.$stateParams.invoiceGuid)
            .catch(e => this.error = e);
    };

}
